import { http } from '../api/http';
import type { BlogPost } from '../types/Blog';
import type {
  BlogCategory,
  BlogCategoryCreateRequest,
  BlogCategoryUpdateRequest
} from '../types/BlogCategory';

export const BlogService = {
  // =========================
  // POSTS (Admin)
  // =========================
  getAdminPosts() {
    return http<BlogPost[]>('/admin/blog/posts');
  },

  getAdminPostById(id: string | number) {
    return http<BlogPost>(`/admin/blog/posts/${id}`);
  },

  createPost(payload: Partial<BlogPost>) {
    return http<BlogPost>('/admin/blog/posts', { method: 'POST', body: payload });
  },

  updatePost(id: string | number, payload: Partial<BlogPost>) {
    return http<BlogPost>(`/admin/blog/posts/${id}`, { method: 'PUT', body: payload });
  },

  deletePost(id: string | number) {
    return http<void>(`/admin/blog/posts/${id}`, { method: 'DELETE' });
  },

  // =========================
  // POSTS (Public/Client)  
  // =========================
  getPublicPosts() {
    return http<BlogPost[]>('/blog/posts');
  },

  getPublicPost(slugOrId: string) {
    return http<BlogPost>(`/blog/posts/${encodeURIComponent(slugOrId)}`);
  },

  // =========================
  // CATEGORIES (Admin) ✅ NUEVO
  // =========================
  getAdminCategories() {
    return http<BlogCategory[]>('/admin/blog/categories');
  },

  createCategory(payload: BlogCategoryCreateRequest) {
    return http<BlogCategory>('/admin/blog/categories', { method: 'POST', body: payload });
  },

  updateCategory(id: string | number, payload: BlogCategoryUpdateRequest) {
    return http<BlogCategory>(`/admin/blog/categories/${id}`, { method: 'PUT', body: payload });
  },

  deleteCategory(id: string | number) {
    return http<void>(`/admin/blog/categories/${id}`, { method: 'DELETE' });
  },

  // (Opcional para cliente/public)
  getPublicCategories() {
    return http<BlogCategory[]>('/blog/categories');
  }
};

export const BlocksService = {
  // =========================
  // PROJECT BLOCKS/RULES
  // =========================
  getRules(projectId: string) {
    return http<{ ok: boolean; data: ProjectBlocksRules }>(`/projects/${projectId}/rules`).then((res) => res.data);
  },

  // =========================
  // INVESTMENTS
  // =========================
  createInvestment(payload: any) {
    return http<any>('/investments', { method: 'POST', body: payload });
  }
};

// Types for ProjectBlocksRules if not defined elsewhere
export interface ProjectBlocksRules {
  // Define the structure based on your API
  [key: string]: any;
}
